module.exports = __webpack_public_path__ + "img/00009.8c7006bc.webp";